"use strict";
window.theme = window.theme || {}
theme.AgeGate = function() {
    function AgeGate() {
        this.legal_age = {
            GB: 18,
            US: 21,
            FR: 18,
            CN: 18,
            INT: 18
        };
        this.site_url = {
            "dev_int" : "https://louis-xiii-dev-int.myshopify.com/",
            "dev_us" : "https://louis-xiii-dev-us.myshopify.com/",
            "dev_fr" : "https://louis-xiii-dev-fr.myshopify.com/",
            "dev_cn" : "https://www.louisxiii-cognac-cn.com/",
            "stg_int" : "https://louis-xiii-staging-int.myshopify.com/",
            "stg_us" : "https://louis-xiii-staging-us.myshopify.com/",
            "stg_fr" : "https://louis-xiii-staging-fr.myshopify.com/",
            "stg_cn" : "https://www.louisxiii-cognac-cn.com/",
            "live_int" : "https://www.louisxiii-cognac.com/",
            "live_us" : "https://us.louisxiii-cognac.com/",
            "live_fr" : "https://fr.louisxiii-cognac.com/",
            "live_cn" : "https://www.louisxiii-cognac-cn.com/"
        };
        this.Selector = {
            js_age_gate_container: document.querySelector('.age-gate-module'),
            js_age_gate_bg: document.querySelector('.age-gate-bg'),
            js_age_gate_range: document.querySelector('[jsagegaterange]'),
            js_year_selected: document.querySelector('.js-year-selected'),
            js_cookies_no_day: document.querySelector('[data-js-cookies-day]'),
            js_age_verification: document.querySelectorAll('.js-age-verification'),
            js_initial_screen: document.querySelector('.js-initial-screen'),
            js_below_legal_age: document.querySelector('.js-below-legal-age'),
            js_age_selection: document.querySelector('.js-age-selection'),
            jsagegatemonthrange: document.querySelector('[jsagegatemonthrange]'),
            jsagegatedayrange: document.querySelector('[jsagegatedayrange]'),
            jsagegateyearrange: document.querySelector('[jsagegateyearrange]'),
            js_month_select: document.querySelector('.js-month-select'),
            js_day_select: document.querySelector('.js-day-select'),
            js_year_select: document.querySelector('.js-year-select'),
            js_body: document.querySelector('body'),
            year_input: document.querySelectorAll('.year-selected > input'),
            birth_year_title: document.querySelector('.age-gate-subtitle'),
            year_selected: document.querySelector('.year-selected'),
            age_gate_title: document.querySelector('.age-gate-title'),
            age_gate_subtitle: document.querySelector('.age-gate-subtitle'),
            age_gate_footer: document.querySelectorAll('.age-gate-footer'),            
            country_selected_recomended_text: document.querySelector('.recomended-version'),
            country_selected_content: document.querySelector('.country-selector-menu .recomended-country')
        };
        this.Button = {
            js_age_gate_confirm: document.querySelector('.js-age-gate-confirm'),
            js_age_gate_back: document.querySelector('.js-age-gate-back'),
            jsagegatemonthrange: document.querySelector('[jsagegatemonthrange]'),
            jsagegatedayrange: document.querySelector('[jsagegatedayrange]'),
            jsagegateyearselectrange: document.querySelector('[jsagegateyearselectrange]'),
            js_age_gate_calculate: document.querySelector('.js-age-gate-calculate'),
            country_list: document.querySelectorAll('ul.age-gate-country-list > li'),
            country_list_btn: document.querySelectorAll('ul.age-gate-country-list > li > a > button'),
            country_list_menu: document.querySelector('.age-gate-country-list'),
            country_selector_menu: document.querySelector('.country-selector-menu'),
            birth_year_btn: document.querySelector('.js-initial-screen > button'),
            editorial_website: document.querySelector('[data-country-code="Global"]')
        };
        if(this.getUrlParamValue('by_pass') == '1'){
            var domain = this.getCookieDomain();

            this.setCookie('age_gate', 'off', domain);
            this.setCookie("customer_age", 30, domain);
        }
        else{
            this.asyncawaitcookiesconsent();
            if(this.getCookie('customer_age') >= this.legal_age.GB){
                if(this.Selector.js_age_gate_container && this.getCookie('age_gate') === 'on') {
                    if(!window.location.href.includes("userID=")){
                      this.load();   
                    }                          
                } else {
                    this.Selector.js_age_gate_container.classList.remove('show');  
                    this.Selector.js_age_gate_container.classList.add('d-none');
                    this.Selector.js_age_gate_bg.classList.add('d-none');
                    this.Selector.js_body.classList.remove('disabled-scrollbar');
                    this.Selector.js_age_gate_bg.classList.add('disabled');
                    this.asyncawaitcookiesconsent();
                };
            }  
            else{
                if(!window.location.href.includes("userID=")){
                    this.load();   
                } 
            }
        }
    }
    AgeGate.prototype.load = function() {
            dataLayer.push({
                event: "age_gate_display" 
            }); 
            var _ = this;

            /**
             * Start Geolocation
             */

            _.location();

            /**
             * End Geolocation
             */

            const init_selected_countries = () => {
                _.Button.country_list.forEach(btn => {
                    if(!btn.classList.contains('selected')) {
                        btn.classList.toggle('to-be-selected'); 
                    }                              
                }) 
                _.Selector.js_age_gate_container.scrollTop = _.Selector.js_age_gate_container.scrollHeight;
            }
            var today = new Date();        
            _.Selector.js_age_gate_container.classList.add('show');  
            _.Selector.js_body.classList.add('disabled-scrollbar');
            _.Selector.js_age_gate_bg.classList.remove('disabled');
            _.Button.country_selector_menu.addEventListener('click', function(e){
                e.stopPropagation();
                this.classList.toggle('open');
                _.Button.country_list_menu.classList.toggle('open');
                init_selected_countries();
            })
            _.Button.country_list.forEach(el => {
                el.addEventListener('click', (event) => {
                    event.stopPropagation();
                    const selected_country_name = event.target.closest('li').getAttribute('data-country-name');
                    _.Selector.country_selected_content.textContent = selected_country_name;
                    _.Button.country_list_menu.classList.toggle('open');
                    _.Button.country_selector_menu.classList.toggle('open');
                    _.Button.country_list.forEach(btn => {
                        if(!btn.classList.contains('selected')) {
                            btn.classList.toggle('to-be-selected'); 
                        }                              
                    })   
                    if(!_.Button.country_list_menu.classList.contains('open')) {
                        _.Button.country_list.forEach(btn => {
                            if(btn.classList.contains('selected')) {
                                btn.classList.add('to-be-selected'); 
                                btn.classList.remove('selected'); 
                            }                              
                        })   
                        let country_selected = event.target.closest('li').getAttribute('data-country-code')
                        _.translateAgeGate(country_selected);
                        _.showInputs(country_selected);
                        localStorage.setItem("country_zip_code", country_selected);
                        event.target.closest('li').classList.add('selected');
                        event.target.closest('li').classList.remove('to-be-selected');
                    }                             
                })
            })               
            document.addEventListener("DOMContentLoaded", function() {
                _.Selector.year_input[0].addEventListener('keyup', (event) => {
                    if(localStorage.getItem("country_zip_code") == "US"){
                        _.Selector.year_input[0].addEventListener('keyup', (event) => {
                            if(event.target.value.length > 1 && _.Selector.year_input[1].value.length > 1 && _.Selector.year_input[2].value.length > 3) {
                                _.calculate(event.target.value + '/' + _.Selector.year_input[1].value + '/' + _.Selector.year_input[2].value);
                            }
                        })
                    }
                    else{
                        if(event.target.value.length == 2) {
                            _.calculate(1);
                        }  
                    }                    
                })
                _.Selector.year_input[1].addEventListener('keyup', (event) => {
                    if(localStorage.getItem("country_zip_code") == "US"){
                        _.Selector.year_input[1].addEventListener('keyup', (event) => {
                            if(_.Selector.year_input[0].value.length > 1 && event.target.value.length > 1 && _.Selector.year_input[2].value.length > 3) {
                                _.calculate(_.Selector.year_input[0].value + '/' + event.target.value + '/' + _.Selector.year_input[2].value);
                            }
                        })
                    }
                    else{
                        if(event.target.value.length == 2) {
                            _.calculate(2);
                        }
                    }
                })
                _.Selector.year_input[2].addEventListener('keyup', (event) => {
                    if(localStorage.getItem("country_zip_code") == "US"){
                        _.Selector.year_input[2].addEventListener('keyup', (event) => {
                            if(_.Selector.year_input[0].value.length > 1 && _.Selector.year_input[1].value.length > 1 && event.target.value.length > 3) {
                                _.calculate(_.Selector.year_input[0].value + '/' + _.Selector.year_input[1].value + '/' + event.target.value);
                            }
                        })
                    }
                    else{
                        if(event.target.value.length == 4) {
                            _.calculate(0);
                        } 
                    }                    
                })
                _.Selector.year_input[0].setAttribute('min', 1);
                _.Selector.year_input[0].setAttribute('max', 12);
                _.Selector.year_input[1].setAttribute('min', 1);
                _.Selector.year_input[1].setAttribute('max', 31);
                _.Selector.year_input[2].setAttribute('max',today.getFullYear());
                _.Selector.year_input[2].setAttribute('min',Number(today.getFullYear()) - 200);
                _.Selector.js_age_gate_bg.classList.add('disabled');
            })
            _.usInputsEvent();   
            _.Selector.birth_year_title.textContent = _.Selector.birth_year_title.getAttribute('data-year-text');  
            _.Button.birth_year_btn.addEventListener('click', () => {
                _.Selector.birth_year_title.textContent = _.Selector.birth_year_title.getAttribute('data-year-text'); 
                _.Button.birth_year_btn.classList.add('d-none');
                _.Selector.year_selected.classList.remove('d-none');
                _.Selector.year_input[0].value = '';
                _.Selector.year_input[1].value = '';
                _.Selector.year_input[2].value = '';
                _.showInputs(localStorage.getItem("country_zip_code"));   
            })
            _.Selector.js_age_gate_container.addEventListener('click', function(e){
                if(_.Button.country_list_menu.classList.contains('open') && _.Button.country_selector_menu.classList.contains('open')){
                    _.Button.country_list_menu.classList.toggle('open');
                    _.Button.country_selector_menu.classList.toggle('open');
                    init_selected_countries();
                }
            });

    }
    AgeGate.prototype.confirm = function(customer_age, country_selected) {
            var _ = this;
            var current_url = window.location.href;
            var staging_env = current_url.includes('staging'); 
            var dev_env = current_url.includes('dev'); 
            var env = "";
            var domain = _.getCookieDomain();

            if(staging_env){
                env += "stg_";
            }
            else if(dev_env){
                env += "dev_";
            }
            else{
                env += "live_";
            }

            _.setCookie('age_gate', 'off', domain);
            _.setCookie("customer_age", customer_age, domain); 
            var event_exist = dataLayer.some(obj => obj.event == "age_gate_validation");
            if(!event_exist){
                dataLayer.push({
                    event: "age_gate_validation"
                });
            }
            switch(country_selected){
                case 'Global': 
                  env += "int";
                  window.location.href = _.site_url[env];
                  break;
                case "FR":
                  env += "fr";
                  window.location.href = _.site_url[env];
                  break;
                case "US":
                  env += "us";
                  window.location.href = _.site_url[env];
                  break;
                case "CN":
                  env += "cn";
                  window.location.href = _.site_url[env];
                  break;
                default :   
                  _.Selector.js_age_gate_container.classList.remove('show');  
                  _.Selector.js_body.classList.remove('disabled-scrollbar');
                  _.Selector.js_age_gate_bg.classList.add('disabled');
                  _.asyncawaitcookiesconsent();
                  break;
            }
    }
    AgeGate.prototype.prohibited = function() {
            var _ = this;
            _.Selector.birth_year_title.textContent = _.Selector.birth_year_title.getAttribute('data-warning-text');
            _.Button.birth_year_btn.classList.remove('d-none');
            _.Selector.year_input[0].classList.add('d-none');
            _.Selector.year_input[1].classList.add('d-none');
            _.Selector.year_input[2].classList.add('d-none');  
            _.Selector.year_selected.classList.add('d-none');
    }    
    AgeGate.prototype.setCookie = function(cname, cvalue, domain = null) {
            var _ = this;
            let noday = _.Selector.js_cookies_no_day.getAttribute('data-js-cookies-day');
            if(isNaN(noday)) {
                noday = 365;
            } else { 
                noday = Number(noday);
            }
            const d = new Date();
            d.setTime(d.getTime() + (noday*24*60*60*1000));
            let expires = 'expires='+ d.toUTCString();
            var cookie  = cname + '=' + cvalue + ';' + expires + ';path=/';
            if(domain != null){
                document.cookie = cookie+";domain="+domain;
            }
            else{
                document.cookie = cookie;
            }
    }
    AgeGate.prototype.getCookie = function(cname) {
            let name = cname+'=';
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for(let i = 0; i <ca.length; i++) {
              let c = ca[i];
              while (c.charAt(0) == ' ') {
                c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
              }
            }
            return 'on';
    }
    AgeGate.prototype.calculate = function(input_index) {
            var _ = this;
            let legal_age = 0;
            let country_selected = "";
            _.Button.country_list.forEach(el => {
                if(el.classList.contains('selected')) {
                  legal_age = Number(el.getAttribute('data-legal-age'));
                  country_selected = el.getAttribute('data-country-code');
                }
            })
            if(country_selected == "US"){
                var birthdate = new Date(input_index);        
                birthdate.setDate(birthdate.getDate() + 1);         
                var ageDifMs = Date.now() - birthdate.getTime();
                var ageDate = new Date(ageDifMs);
                var actualAge = Math.abs(ageDate.getUTCFullYear() - 1970);
               if(actualAge >= legal_age) {
                    _.confirm(actualAge, country_selected);
                } else {
                    _.prohibited();
                }
                return;
            }
            else{
                const d = new Date();
                let current_year = d.getFullYear();
                let current_month = Number(d.getMonth()) + 1;
                let current_day =  Number(d.getDate());
                let customer_age = Number(current_year) - Number(_.Selector.year_input[2].value);
                switch(input_index) {
                    case 1:
                      // month              
                      if(Number(_.Selector.year_input[0].value) < Number(current_month)) {
                        _.confirm(customer_age, country_selected);
                      }
                      if(Number(_.Selector.year_input[0].value) == Number(current_month)) {
                        _.Selector.birth_year_title.textContent = _.Selector.birth_year_title.getAttribute('data-day-text');
                        _.Selector.year_input[0].classList.add('d-none');
                        _.Selector.year_input[1].classList.remove('d-none');
                        _.Selector.year_input[1].focus();      
                      }                  
                      if(Number(_.Selector.year_input[0].value) > Number(current_month)) {
                       _.prohibited();
                      }
                      break;
                    case 2:
                      // day            
                      if(Number(_.Selector.year_input[1].value) < Number(current_day)) {
                        _.confirm(customer_age, country_selected);
                      }
                      if(Number(_.Selector.year_input[1].value) >= Number(current_day)) {
                        _.prohibited();
                      }
                      break;
                    default:
                      // year                           
                      let estimated_year = Number(current_year) - Number(legal_age);           
                      if(Number(_.Selector.year_input[2].value)<Number(estimated_year)) {
                        _.confirm(customer_age, country_selected);
                      }
                      if(Number(_.Selector.year_input[2].value) == Number(estimated_year)) {
                        _.Selector.birth_year_title.textContent = _.Selector.birth_year_title.getAttribute('data-month-text');
                        _.Selector.year_input[2].classList.add('d-none');
                        _.Selector.year_input[0].classList.remove('d-none');
                        _.Selector.year_input[0].focus();      
                      }                  
                      if(Number(_.Selector.year_input[2].value) > Number(estimated_year)) {
                       _.prohibited();
                      }
                }

            }
    }
    AgeGate.prototype.location = function() {
        var _ = this;
        fetch('/browsing_context_suggestions.json')
            .then((resp) => resp.json())
            .then(function(data) {
                let country_zip_code = data.detected_values.country.handle;
                let country_elem = document.querySelector('[data-country-code='+country_zip_code+']');
                if(country_elem){
                    _.Selector.country_selected_content.textContent = country_elem.getAttribute('data-country-name');
                    country_elem.classList.remove("to-be-selected");
                    country_elem.classList.add("selected");
                }
                else{
                    _.Selector.country_selected_content.textContent = "GLOBAL"
                    _.Button.editorial_website.classList.remove("to-be-selected");
                    _.Button.editorial_website.classList.add("selected");
                }
                _.translateAgeGate(country_zip_code);
                _.showInputs(country_zip_code);
                localStorage.setItem("country_zip_code", country_zip_code);
            })
    }
    AgeGate.prototype.asyncawaitcookiesconsent = async function () {
        while (!document.getElementById("onetrust-banner-sdk")) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        const banner = document.getElementById("onetrust-banner-sdk");
        banner.style.setProperty("opacity", 1);
    };
    AgeGate.prototype.translateAgeGate = function(country) {
        var _ = this;
        let legal_age = country == "US" ? _.legal_age.US : _.legal_age.INT;
        let site_url = country == "US" ? _.site_url.live_us : country == "GB" ? "/" : _.site_url.live_int;
        let title = "";
        let sub_title = "";
        let warning_text = "";
        let year_text = "";
        let month_text = "";
        let day_text = "";
        let footer_text = "";
        let mistake_msg = "";
        let recomended_version_text = "";
        switch(country){
            case "FR": 
                title = "Pour utiliser ce site, vous devez être en âge d’acheter et de consommer de l’alcool dans votre pays de résidence. Si votre pays ne prévoit pas de législation spécifiquement sur ce point, vous devez avoir au moins "+_.legal_age.FR+" ans.";
                footer_text = "<p>En visitant ce site web, vous acceptez nos <a href='"+_.site_url.live_fr+"pages/mentions-legales'>conditions générales d’utilisation </a>, notre <a href='"+_.site_url.live_fr+"pages/politique-de-confidentialite'>politique de confidentialité et notre politique de cookies.</a></p>\n<p>S'IL VOUS PLAÎT PROFITEZ DE MANIÈRE RESPONSABLE. LOUIS XIII soutient la consommation responsable de ses produits à travers le groupe Rémy Cointreau, membre de Spirits EUROPE, DISCUS, Avec Modération! et FSPA. Licence chinoise :沪ICP备13038051</p>";
                sub_title = "Veuillez entrer votre année de naissance";
                warning_text = "Désolé, vous n’êtes pas assez âgé pour accéder à notre site web";
                year_text = "Veuillez entrer votre année de naissance";
                month_text = "Veuillez entrer votre mois de naissance";
                day_text = "Veuillez entrer votre jour de naissance";
                mistake_msg = "J'ai fait une erreur";
                recomended_version_text = "Version recommandée";
                break;
            case "CN":
                title = "您必须符合所在国家或地区规定的法定饮酒年龄方可浏览此网站<br>若无相关法律法规，则需年满"+_.legal_age.CN+"周岁方可继续浏览";
                footer_text = "<p>继续访问网站，即代表您同意 我们的法律声明与条款、 <a href='"+_.site_url.live_cn+"privacy-policy.html'> 《隐私政策》 </a>, 及 <a href='"+_.site_url.live_cn+"cookies-policy.html'>《Cookies 政策》</a><\/p>\n<p>尊享有度。作为人头马集团 (Remy Cointreau Group) 旗下一员，路易十三希望点滴臻酿均得到有度享用。人头马集团已加入欧洲酒业联盟 (Spirits EUROPE)<br>美国蒸馏酒协会 (DISCUS). 备案号 : 沪ICP备13038051号-15<\/p>";
                sub_title = "请输入您的出生年份";
                warning_text = "对不起,您的年龄还未到饮酒合法年龄";
                year_text = "请输入您的出生年份";
                month_text = "請輸入您的出生月份";
                day_text = "請輸入您的出生日期";
                mistake_msg = "我犯了一個錯誤";
                recomended_version_text = "推荐版本";
                break;
            default:
                title = "To use this site, you must be of legal age to buy and consume alcohol in your country of residence. If there is no legislation in this regard in your country, you must be at least "+legal_age+" years old.";
                footer_text = "<p>By visiting this website you are agreeing with our <a href='"+site_url+"pages/legal-notices-and-terms'>Legal Notices and terms </a>, our <a href='"+site_url+"pages/privacy-policy'>Privacy Policy and our Cookies Policy.</a><\/p>\n<p>PLEASE ENJOY RESPONSIBLY. LOUIS XIII supports the responsible consumption of its products through Remy Cointreau Group, member of Spirits EUROPE., DISCUS, Avec Modération! And FSPA. Chinese licence :沪ICP备13038051号-8<\/p>";
                sub_title = "Please, enter your year of birth";
                warning_text = "Sorry, you are not old enough to access to the website";
                year_text = "Please, enter your year of birth";
                month_text = "Please, enter your month of birth";
                day_text = "Please, enter your day of birth";
                mistake_msg = "I made a Mistake";
                recomended_version_text = "Recommended version";
                break;
        }
        _.Selector.country_selected_recomended_text.textContent = recomended_version_text;
        _.Selector.age_gate_title.innerHTML = title;
        _.Selector.age_gate_subtitle.innerHTML = sub_title;
        _.Selector.age_gate_footer[0].innerHTML = footer_text;
        _.Selector.age_gate_footer[1].innerHTML = footer_text;
        _.Button.birth_year_btn.innerHTML = mistake_msg;
        _.Selector.age_gate_subtitle.setAttribute("data-warning-text", warning_text);
        _.Selector.age_gate_subtitle.setAttribute("data-year-text", year_text);
        _.Selector.age_gate_subtitle.setAttribute("data-month-text", month_text);
        _.Selector.age_gate_subtitle.setAttribute("data-day-text", day_text);
    }
    AgeGate.prototype.showInputs = function(country){
        var _ = this;
        if(country == "US"){
            _.Selector.year_selected.classList.add("us-inputs");
            _.Selector.year_input[0].classList.remove('d-none');
            _.Selector.year_input[1].classList.remove('d-none');
            _.Selector.year_input[2].classList.remove('d-none');
            _.Selector.year_input[0].focus();
        }
        else{
            _.Selector.year_selected.classList.remove("us-inputs");
            _.Selector.year_input[0].classList.add('d-none');
            _.Selector.year_input[1].classList.add('d-none');
            _.Selector.year_input[2].classList.remove('d-none');
            _.Selector.year_input[2].focus();
        }
    }
    AgeGate.prototype.usInputsEvent = function (){
        var _ = this;
        _.Selector.year_input[0].addEventListener('keyup', event => {
            if(localStorage.getItem("country_zip_code") == "US"){
                if(event.target.value.length > 1) {
                    _.Selector.year_input[1].focus();
                }
                if(event.keyCode == 39) {
                    _.Selector.year_input[1].focus();
                }
                if(event.target.value > 12) {
                    event.target.value = 12;
                }
                if(event.target.value === '00') {
                    event.target.value = '01';
                }
            }
        })   
        _.Selector.year_input[1].addEventListener('keyup', event => {
            if(localStorage.getItem("country_zip_code") == "US"){
                if(event.target.value.length > 1) {
                    _.Selector.year_input[2].focus();
                }
                if(event.keyCode == 8 && event.target.value.length == 0) {
                    _.Selector.year_input[0].focus();
                }
                if(event.keyCode == 39) {
                    _.Selector.year_input[2].focus();
                }
                if(event.keyCode == 37) {
                    _.Selector.year_input[0].focus();
                }
                if(event.target.value > 31) {
                    event.target.value = 31;
                }
                if(event.target.value === '00') {
                    event.target.value = '01';
                }
            }
        })   
        _.Selector.year_input[2].addEventListener('keyup', event => {
            if(localStorage.getItem("country_zip_code") == "US"){
                if(event.keyCode == 8 && event.target.value.length == 0) {
                    _.Selector.year_input[1].focus();
                }
                if(event.keyCode == 37) {
                    _.Selector.year_input[1].focus();
                }
            }
        })  
    }
    AgeGate.prototype.getUrlParamValue = function (name){
        const queryString = window.location.search; 
        const urlParams = new URLSearchParams(queryString); 
        const value = urlParams.get(name); 
        return value;
    }
    AgeGate.prototype.getCookieDomain = function (){
        var domain = null;
        if(window.location.href.indexOf("dev") == -1 && window.location.href.indexOf("staging") == -1 && window.location.href.indexOf('shopifypreview') == -1 && window.location.href.indexOf('prod') == -1){
            domain = ".louisxiii-cognac.com";
        }
        return domain;
    }

    theme.AgeGate = new AgeGate;
}

theme.AgeGate();
